import { IKeyValue, resourceNameKeyValues } from "motw_core/Entity/IKeyValue";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { GetDefaultKeyValue } from "./defaultKeyValue";

export interface ISetKeyValueJsonOptions {
    expiry?: number;
    /** Serialized value retained for callers that still read the legacy column. */
    legacyValue?: string;
}

export async function SetKeyValueJsonAsync<T>(
    key: string,
    valueJson: T,
    options: ISetKeyValueJsonOptions = {}
): Promise<void> {
    const resource = GetKeyValueResource(key);
    const existingKeyValues = await ClientDataProvider.GetRecordsAsync<IKeyValue>(
        resource
    );
    const expiry = options.expiry ?? 0;
    const update = {
        value_json: valueJson,
        expiry,
        ...(options.legacyValue === undefined
            ? {}
            : { value: options.legacyValue }),
    };

    if (existingKeyValues.length) {
        await ClientDataProvider.UpdateRecordAsync(resource, update);
        return;
    }

    const newKeyValue = {
        ...GetDefaultKeyValue(),
        key,
        value: options.legacyValue ?? "",
        value_json: valueJson,
        expiry,
    };

    delete (newKeyValue as Partial<IKeyValue>).id;

    await ClientDataProvider.AddRecordAsync(
        resourceNameKeyValues,
        newKeyValue
    );
}

export async function GetKeyValueJsonAsync<T>(
    key: string
): Promise<T | undefined> {
    const keyValues = await ClientDataProvider.GetRecordsAsync<IKeyValue>(
        GetKeyValueResource(key)
    );
    const keyValue = keyValues[0];

    if (!keyValue) {
        return undefined;
    }

    if (
        keyValue.value_json !== undefined &&
        keyValue.value_json !== null &&
        keyValue.value_json !== ""
    ) {
        return keyValue.value_json as T;
    }

    if (!keyValue.value) {
        return undefined;
    }

    try {
        return JSON.parse(keyValue.value) as T;
    } catch {
        return keyValue.value as T;
    }
}

function GetKeyValueResource(key: string): string {
    return `${resourceNameKeyValues}?key=eq.${encodeURIComponent(key)}`;
}
